module.exports = __webpack_public_path__ + "static/media/backtotop.0c6bc1a1.svg";